/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: {
    primary: { light }
  },
  spacing: { unit }
}) => ({
  gridContainer: {
    '& .ag-body-viewport': {
      maxHeight: 1200,
      overflowY: 'auto'
    },
    '& .ag-header-select-all': {
      '& .ag-icon-checkbox-checked': {
        color: '#333'
      },
      marginRight: 5
    },
    '& .ag-row-error': {
      backgroundColor: '#fde7e0'
    },
    '& .ag-row-success': {
      backgroundColor: '#e4fafc'
    },
    '& .daterangepicker.show-calendar.opensright': {
      position: 'relative'
    },
    '& [class^="Actions-wrapper"] button': {
      background: 'transparent'
    },
    '& [data-qa="bulkButtons"] .btn': {
      padding: [0, 25]
    },
    '& input': {
      border: '1px solid #CCCCCC'
    },
    '& select': {
      border: '1px solid #CCCCCC'
    },
    "& .ag-header-cell button[class^='header']": {
      lineHeight: `${1.625 * unit}px`
    }
  },
  gridRootOverride: {
    '& [class^="grid"]': {
      marginBottom: 0
    },
    '& [class*="controls"]': {
      '& button:focus': {
        outline: `1px solid ${light || '-webkit-focus-ring-color'}`,
        borderColor: light || '-webkit-focus-ring-color'
      }
    },
    '& [class*="root"]': {
      boxShadow: 'none'
    },
    '& [data-qa*="bulkButtons"]': {
      marginBottom: 0
    },
    '& > div > [class*="root"] > [class^="wrapper"]': {
      padding: [0, 20]
    },
    '& [class*="filterWrapper"] article': {
      padding: [1, 26],
      margin: 0,
      '& [class*="wrapper"]': {
        '& > [role="combobox"]': {
          padding: '5px 40px 8px 16px'
        },
        '& > [class*="dropdown"]': {
          '& > label': {
            display: 'none'
          },
          '& + input': {
            width: '50%'
          }
        }
      }
    },
    [`@media only screen and (max-width: 650px)`]: {
      '& [class^="controls"]': {
        flex: 'unset',
        flexWrap: 'wrap',
        justifyContent: 'end',
        '& [class^="lastSyncWrapper"]': {
          width: '100%',
          justifyContent: 'end'
        }
      }
    }
  },
  root: {
    marginBottom: '0 !important'
  },
  allRows: {
    '& .ag-body-viewport': {
      maxHeight: 'none'
    }
  },
  printGrid: {
    '@media print': {
      height: '1px',
      overflow: 'visible',
      '*': {
        transition: 'none !important'
      },
      transition: 'none !important'
    }
  },
  printWidth: {
    // The minimum width is landscape tabloid.
    // We need to set a consistent width for printing so that columns can be adjusted for that width.
    // This sets a consistent width for printing so that column width isn't dependent on your browser window size.
    minWidth: '17in',
    '& [ref="gridBody"]': {
      overflow: 'visible',
      flex: 'none',
      width: 'auto'
    }
  },
  printHeader: {
    marginLeft: 30,
    marginTop: 30,
    textTransform: 'uppercase'
  },
  wrapCell: {
    '&.ag-cell': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: 1.5,
      padding: [10, 0]
    }
  }
});

export { styles };
export default createUseStyles(styles);
